import React, { useState } from "react";
import DriverRepositoryTabs from "./driver_repository_tabs";
import DriverRepositoryBody from "./driver_repository_body";
import CommonSearchFiled from "../../../components/commonSearchField";
import StatusDropdown from "./status_dropdown";
import MyPagination from "../../../components/pagination/pagination";
import StringUtils from "../../../utils/string_utils";
import {footerStyles} from "../../../components/style/common_style";

const options = ["All", "Active", "Inactive"];

const DriverRepositoryPage = () => {
  const [activeTab, setActiveTabs] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [statusList, setStatusList] = useState(options);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [driverListCount, setDriverListCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPage] = useState(1);
  const [isStart, setIsStart] = useState(false);

  const handleDropDownOnchange = (event) => {
    const newValue = event.target.value;
    setSelectedStatus(newValue);
    handleCountUpdate();
    setPage(0);
  };

  const handleOnChangeTabs = (events, updatedTabValue) => {
    setActiveTabs(updatedTabValue);
  };

  const handleCountUpdate = (driverListCount, totalPageCount) => {
    setDriverListCount(driverListCount);
    setTotalPage(totalPageCount);
  };

  const selectedTabContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <div>
            <DriverRepositoryBody
              query={searchText}
              status={selectedStatus}
              pageSize={pageSize}
              currentPage={page + 1}
              onCountUpdate={handleCountUpdate}
            />
          </div>
        );
      default:
        return (
          <div>
            <DriverRepositoryBody
              query={searchText}
              status={selectedStatus}
              pageSize={pageSize}
              currentPage={page + 1}
              onCountUpdate={handleCountUpdate}
            />
          </div>
        );
    }
  };
  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <DriverRepositoryTabs
          activeTabValue={activeTab}
          handleOnChangeTabs={handleOnChangeTabs}
          count={driverListCount}
        />
        <div style={{ display: "flex", marginTop: "5px" }}>
          <CommonSearchFiled
            label={StringUtils.search}
            onSearch={(text) => {
              handleCountUpdate();
              setPage(0);
              setSearchText(text);
            }}
            onClear={() => {
              handleCountUpdate();
              setPage(0);
              setSearchText("");
            }}
            width="400px"
            borderRadius="8px"
          />

          <StatusDropdown
            selectedValue={selectedStatus}
            options={statusList}
            onChange={handleDropDownOnchange}
          />
        </div>
      </div>
      {selectedTabContent()}

      {driverListCount !== 0 && (
        <div style={{marginLeft: "15px",marginTop:"10px",...footerStyles}}>
          <MyPagination
            currentPage={page + 1}
            totalPages={totalPages}
            onPageChange={setPage}
            rowsPerPage={pageSize}
            onRowsPerPageChange={setPageSize}
            totalEntries={driverListCount}
            setIsStart={setIsStart}
            marginRight={localStorage.getItem('isFromHostApplication') ? "11rem" : "5px"}
          />
        </div>
      )}
    </>
  );
};

export default DriverRepositoryPage;
